var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "#9B51E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7288 9.66827C18.0979 9.25741 18.064 8.62515 17.6532 8.25608C17.2423 7.88701 16.61 7.92089 16.241 8.33175L10.6451 14.5612L7.68586 11.7723C7.28394 11.3935 6.65105 11.4122 6.27226 11.8142C5.89348 12.2161 5.91223 12.849 6.31415 13.2277L10.0125 16.7132C10.0203 16.7207 10.0283 16.7281 10.0364 16.7354C10.347 17.0144 10.7841 17.0631 11.1385 16.8927C11.2477 16.8402 11.3491 16.7668 11.4365 16.6729C11.4417 16.6673 11.4467 16.6618 11.4517 16.6561L17.7288 9.66827Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChecked);
export default __webpack_public_path__ + "static/media/ico-checked.5f9c69f0213c081879ab1074b7ca09ab.svg";
export { ForwardRef as ReactComponent };